import { Component, OnInit } from '@angular/core';
import { BroadcastService, BroadcastEventModel, ToasterType } from '@cv-invision/core';
import { QualityDocumentService } from '../../../service/document-quality.service';
import { ORDER_ACTIONS_MESSAGE } from '../../../model/quality.constant';
import { Router } from '@angular/router';

export const APPROVE_ORDER_EVENT = 'approveOrderEvent';
@Component({
	selector: 'cv-approve-modal',
	templateUrl: './approve-modal.component.html',
	styleUrls: ['./approve-modal.component.scss']
})
export class ApproveModalComponent {
	dataOrder: any;
	isOpen: boolean;
	approving: boolean;
	constructor(
		private broadcastService: BroadcastService,
		private qualityDocumentService: QualityDocumentService,
		private router: Router
	) {
		this.registerApproveListener();
	}

	/**
	 * Register Lister to Show/Hide modal
	 *
	 */
	private registerApproveListener(): void {
		this.broadcastService.on(APPROVE_ORDER_EVENT, (broadcast: BroadcastEventModel) => {
			this.dataOrder = broadcast.event.data;
			this.isOpen = true;
			this.approving = false;
		});
	}

	/**
	 * Approve the current order
	 */
	approveOrder(): void {
		this.approving = true;
		this.qualityDocumentService.approveOrder(this.dataOrder.id).subscribe(r => {
			if (r.isValid) {
				 this.isOpen = false;
				 this.OrderNotifications(ToasterType.SUCCESS, ORDER_ACTIONS_MESSAGE.APPROVED);
				 this.returnToMainModule();
			}
		});
	}

	/**
	 * close box
	 */
	closeApproveBox(): void {
		this.isOpen = false;
	}

	/**
	 * return to the main intelligence module
	 */
	returnToMainModule(): void {
		setTimeout(() => {
			this.router.navigate(['/intelligence/inbox']);
		}, 500);
	}

	/**
	 * display a notification depend on the action
	 * @param type type of notification
	 * @param msg message notification
	 */
	private OrderNotifications(type: ToasterType, msg: string): void {
		this.broadcastService.broadcast({
			name: type,
			event: {
				message: msg
			}
		});
	}
}
